import { render } from "./SurveyBox.vue?vue&type=template&id=620a29d3"
import script from "./SurveyBox.vue?vue&type=script&lang=js"
export * from "./SurveyBox.vue?vue&type=script&lang=js"

import "./SurveyBox.vue?vue&type=style&index=0&id=620a29d3&lang=css"

import exportComponent from "/home/devops/vsts-agent/_work/20/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__